import { Outlet } from "react-router-dom";

/**
 * Layout component for authentication pages.
 * Provides a clean, centered layout for login and other auth screens.
 */
export const AuthLayout = () => {
	return (
		<div className="flex min-h-screen flex-col bg-gray-50">
			<main className="flex flex-1 items-center justify-center px-4 sm:px-6 lg:px-8">
				<div className="w-full max-w-md">
					<Outlet />
				</div>
			</main>
		</div>
	);
};
